const validate = values => {

  const errors = {};

  if (!values.date) {
    errors.date = 'Required';
  }
  if (!values.timeslot) {
    errors.timeslot = 'Required';
  }

  return errors;
};
export default validate;


// WEBPACK FOOTER //
// ./app/booking/components/validate.js